import { AttributeSpec, Mark, ProseMirrorNode } from 'prosemirror-model';

// function removeUndefinedProperties(obj: any): any {
//   if (Array.isArray(obj)) {
//     return obj.map(item => removeUndefinedProperties(item));
//   } else if (typeof obj === 'object' && obj !== null) {
//     const newObj: any = {};
//     for (const key in obj) {
//       if (obj[key] !== undefined) {
//         newObj[key] = removeUndefinedProperties(obj[key]);
//       }
//     }
//     return newObj;
//   } else {
//     return obj;
//   }
// }

/**
 * Converts a ProseMirror node to a JSON object.
 * @param node The ProseMirror node to convert to JSON.
 * @returns The JSON object representing the ProseMirror node.
 */
export function nodeToJSON(node: ProseMirrorNode): any {
  const nodeJSON: any = { type: node.type.name };

  // Add the attrs
  if (node.attrs) {
    const attrs = attrsToJSON(node.attrs, node.type.spec.attrs);
    if (Object.keys(attrs).length > 0) {
      nodeJSON.attrs = attrs;
    }
  }

  // Add the content
  if (node.content.size > 0) {
    nodeJSON.content = contentToJSON(node);
  }

  // Add the marks
  if (node.marks.length > 0) {
    nodeJSON.marks = node.marks.map(mark => markToJSON(mark));
  }

  // Set the text if it is a text node
  if (node.isText) {
    nodeJSON.text = node.text;
  }

  return nodeJSON;
}

/**
 * Converts a ProseMirror node's content to a JSON array.
 * @param node The ProseMirror node whose content to convert to JSON.
 * @returns The JSON array representing the ProseMirror node's content.
 */
export function contentToJSON(node: ProseMirrorNode): any[] {
  const nodes: any[] = [];

  for (let i = 0; i < node.childCount; i += 1) {
    nodes.push(nodeToJSON(node.child(i)));
  }

  return nodes;
}

/**
 * Converts a ProseMirror mark to a JSON object.
 * @param mark The ProseMirror mark to convert to JSON.
 * @returns The JSON object representing the ProseMirror mark.
 */
export function markToJSON(mark: Mark): any {
  const markJSON: any = { type: mark.type.name };

  // Add the attrs
  if (mark.attrs) {
    const attrs = attrsToJSON(mark.attrs, mark.type.spec.attrs);
    if (Object.keys(attrs).length > 0) {
      markJSON.attrs = attrs;
    }
  }

  return markJSON;
}

/**
 * Converts a ProseMirror node or mark's attributes to a JSON object.
 * Attribute values that are undefined or null are not included in the JSON object.
 * @param attributes The attributes to convert to JSON.
 * @param attrsSpecs The attribute specs for the node or mark.
 * @returns The JSON object representing the attributes.
 */
export function attrsToJSON(attributes: Dictionary<string | number>, attrsSpecs: Dictionary<AttributeSpec>): Dictionary {
  const obj: Dictionary = {};

  if (attributes) {
    for (let [attributeName, value] of Object.entries(attributes)) {
      // Skip attributes that should not be exported to JSON
      if (attrsSpecs?.[attributeName]?.skipJSONExport) {
        continue;
      }

      if (typeof value !== 'undefined' && value !== null) {
        obj[attributeName] = value;
      }
    }
  }

  return obj;
}
